import {WebsocketMessage} from './websocketMessage';

export class TrainWebsocketMessage extends WebsocketMessage {
  body: any[]; // Any because locomotives and train-fidelity don't have types
  target: 'trains' | 'train-schedules' | 'locomotives' | 'train-history' | 'train-fidelity';
}
